/**
 * Generated by orval v6.8.1 🍺
 * Do not edit manually.
 * Core API
 * The Blueprint Core API description
 * OpenAPI spec version: 1.0
 */
import {
  useQuery,
  useMutation,
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey
} from 'react-query'
import type {
  UserDto,
  ForgotPasswordBodyDto,
  ForgotPasswordSetNewPasswordBodyDto,
  ClientDto,
  SessionCompletedDto,
  PatientInterventionDto,
  ClientStartInterventionsBodyDto,
  ClientControllerGetStartedInterventionsParams,
  ApiExceptionDto,
  AssignedAssessmentDto,
  SubmittedAssessmentsDto,
  SubmittedAssessmentsBodyDto,
  UserControllerPostSubmitAssessmentParams,
  ConsentInfoDto,
  BranchLinkDto,
  KioskClinicDto,
  KioskClientDto,
  KioskIdentifyClientDto,
  KioskIdentifyClientFromAttributesBodyDto,
  KioskIdentifyClientFromMRNBodyDto,
  SessionDraftDto,
  SessionCreateBodyDto,
  SessionFromUploadedAudioBodyDto,
  StartUploadDto,
  CompleteUploadDto,
  SampleSessionDto,
  SessionProgressNoteDto,
  TrackEventDto,
  PatchNoteDto,
  SessionRecapDto,
  MarkCompleteDto,
  SessionPlannedInterventionsBodyDto,
  SessionPsychotherapyNoteBodyDto
} from './models'
import { customInstance, ErrorType } from './axios-instance'



export const accountControllerGetAccount = (
    
 signal?: AbortSignal
) => {
      return customInstance<UserDto>(
      {url: `/account`, method: 'get', signal
    },
      );
    }
  

export const getAccountControllerGetAccountQueryKey = () => [`/account`];

    
export type AccountControllerGetAccountQueryResult = NonNullable<Awaited<ReturnType<typeof accountControllerGetAccount>>>
export type AccountControllerGetAccountQueryError = ErrorType<void>

export const useAccountControllerGetAccount = <TData = Awaited<ReturnType<typeof accountControllerGetAccount>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof accountControllerGetAccount>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions} = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getAccountControllerGetAccountQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof accountControllerGetAccount>>> = ({ signal }) => accountControllerGetAccount(signal);

  const query = useQuery<Awaited<ReturnType<typeof accountControllerGetAccount>>, TError, TData>(queryKey, queryFn, queryOptions)

  return {
    queryKey,
    ...query
  }
}


export const accountControllerPostForgotPasswordRequestCode = (
    forgotPasswordBodyDto: ForgotPasswordBodyDto,
 
) => {
      return customInstance<void>(
      {url: `/account/forgot-password/request-code`, method: 'post',
      headers: {'Content-Type': 'application/json'},
      data: forgotPasswordBodyDto
    },
      );
    }
  


    export type AccountControllerPostForgotPasswordRequestCodeMutationResult = NonNullable<Awaited<ReturnType<typeof accountControllerPostForgotPasswordRequestCode>>>
    export type AccountControllerPostForgotPasswordRequestCodeMutationBody = ForgotPasswordBodyDto
    export type AccountControllerPostForgotPasswordRequestCodeMutationError = ErrorType<unknown>

    export const useAccountControllerPostForgotPasswordRequestCode = <TError = ErrorType<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof accountControllerPostForgotPasswordRequestCode>>, TError,{data: ForgotPasswordBodyDto}, TContext>, }
) => {
      const {mutation: mutationOptions} = options ?? {}

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof accountControllerPostForgotPasswordRequestCode>>, {data: ForgotPasswordBodyDto}> = (props) => {
          const {data} = props ?? {};

          return  accountControllerPostForgotPasswordRequestCode(data,)
        }

      return useMutation<Awaited<ReturnType<typeof accountControllerPostForgotPasswordRequestCode>>, TError, {data: ForgotPasswordBodyDto}, TContext>(mutationFn, mutationOptions)
    }
    
export const accountControllerPostForgotPasswordResetConfirmCode = (
    forgotPasswordSetNewPasswordBodyDto: ForgotPasswordSetNewPasswordBodyDto,
 
) => {
      return customInstance<void>(
      {url: `/account/forgot-password/set-new-password`, method: 'post',
      headers: {'Content-Type': 'application/json'},
      data: forgotPasswordSetNewPasswordBodyDto
    },
      );
    }
  


    export type AccountControllerPostForgotPasswordResetConfirmCodeMutationResult = NonNullable<Awaited<ReturnType<typeof accountControllerPostForgotPasswordResetConfirmCode>>>
    export type AccountControllerPostForgotPasswordResetConfirmCodeMutationBody = ForgotPasswordSetNewPasswordBodyDto
    export type AccountControllerPostForgotPasswordResetConfirmCodeMutationError = ErrorType<unknown>

    export const useAccountControllerPostForgotPasswordResetConfirmCode = <TError = ErrorType<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof accountControllerPostForgotPasswordResetConfirmCode>>, TError,{data: ForgotPasswordSetNewPasswordBodyDto}, TContext>, }
) => {
      const {mutation: mutationOptions} = options ?? {}

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof accountControllerPostForgotPasswordResetConfirmCode>>, {data: ForgotPasswordSetNewPasswordBodyDto}> = (props) => {
          const {data} = props ?? {};

          return  accountControllerPostForgotPasswordResetConfirmCode(data,)
        }

      return useMutation<Awaited<ReturnType<typeof accountControllerPostForgotPasswordResetConfirmCode>>, TError, {data: ForgotPasswordSetNewPasswordBodyDto}, TContext>(mutationFn, mutationOptions)
    }
    
export const clientControllerGetProfile = (
    id: string,
 signal?: AbortSignal
) => {
      return customInstance<ClientDto>(
      {url: `/client/${id}/profile`, method: 'get', signal
    },
      );
    }
  

export const getClientControllerGetProfileQueryKey = (id: string,) => [`/client/${id}/profile`];

    
export type ClientControllerGetProfileQueryResult = NonNullable<Awaited<ReturnType<typeof clientControllerGetProfile>>>
export type ClientControllerGetProfileQueryError = ErrorType<void>

export const useClientControllerGetProfile = <TData = Awaited<ReturnType<typeof clientControllerGetProfile>>, TError = ErrorType<void>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof clientControllerGetProfile>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions} = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getClientControllerGetProfileQueryKey(id);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof clientControllerGetProfile>>> = ({ signal }) => clientControllerGetProfile(id, signal);

  const query = useQuery<Awaited<ReturnType<typeof clientControllerGetProfile>>, TError, TData>(queryKey, queryFn, {enabled: !!(id), ...queryOptions})

  return {
    queryKey,
    ...query
  }
}


export const clientControllerGetSessions = (
    id: string,
 signal?: AbortSignal
) => {
      return customInstance<SessionCompletedDto[]>(
      {url: `/client/${id}/completed-sessions`, method: 'get', signal
    },
      );
    }
  

export const getClientControllerGetSessionsQueryKey = (id: string,) => [`/client/${id}/completed-sessions`];

    
export type ClientControllerGetSessionsQueryResult = NonNullable<Awaited<ReturnType<typeof clientControllerGetSessions>>>
export type ClientControllerGetSessionsQueryError = ErrorType<void>

export const useClientControllerGetSessions = <TData = Awaited<ReturnType<typeof clientControllerGetSessions>>, TError = ErrorType<void>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof clientControllerGetSessions>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions} = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getClientControllerGetSessionsQueryKey(id);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof clientControllerGetSessions>>> = ({ signal }) => clientControllerGetSessions(id, signal);

  const query = useQuery<Awaited<ReturnType<typeof clientControllerGetSessions>>, TError, TData>(queryKey, queryFn, {enabled: !!(id), ...queryOptions})

  return {
    queryKey,
    ...query
  }
}


export const clientControllerPostStartInterventions = (
    id: string,
    clientStartInterventionsBodyDto: ClientStartInterventionsBodyDto,
 
) => {
      return customInstance<PatientInterventionDto[]>(
      {url: `/client/${id}/start-interventions`, method: 'post',
      headers: {'Content-Type': 'application/json'},
      data: clientStartInterventionsBodyDto
    },
      );
    }
  


    export type ClientControllerPostStartInterventionsMutationResult = NonNullable<Awaited<ReturnType<typeof clientControllerPostStartInterventions>>>
    export type ClientControllerPostStartInterventionsMutationBody = ClientStartInterventionsBodyDto
    export type ClientControllerPostStartInterventionsMutationError = ErrorType<void>

    export const useClientControllerPostStartInterventions = <TError = ErrorType<void>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clientControllerPostStartInterventions>>, TError,{id: string;data: ClientStartInterventionsBodyDto}, TContext>, }
) => {
      const {mutation: mutationOptions} = options ?? {}

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clientControllerPostStartInterventions>>, {id: string;data: ClientStartInterventionsBodyDto}> = (props) => {
          const {id,data} = props ?? {};

          return  clientControllerPostStartInterventions(id,data,)
        }

      return useMutation<Awaited<ReturnType<typeof clientControllerPostStartInterventions>>, TError, {id: string;data: ClientStartInterventionsBodyDto}, TContext>(mutationFn, mutationOptions)
    }
    
export const clientControllerGetStartedInterventions = (
    id: string,
    params?: ClientControllerGetStartedInterventionsParams,
 signal?: AbortSignal
) => {
      return customInstance<PatientInterventionDto[]>(
      {url: `/client/${id}/started-interventions`, method: 'get', signal,
        params,
    },
      );
    }
  

export const getClientControllerGetStartedInterventionsQueryKey = (id: string,
    params?: ClientControllerGetStartedInterventionsParams,) => [`/client/${id}/started-interventions`, ...(params ? [params]: [])];

    
export type ClientControllerGetStartedInterventionsQueryResult = NonNullable<Awaited<ReturnType<typeof clientControllerGetStartedInterventions>>>
export type ClientControllerGetStartedInterventionsQueryError = ErrorType<void>

export const useClientControllerGetStartedInterventions = <TData = Awaited<ReturnType<typeof clientControllerGetStartedInterventions>>, TError = ErrorType<void>>(
 id: string,
    params?: ClientControllerGetStartedInterventionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof clientControllerGetStartedInterventions>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions} = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getClientControllerGetStartedInterventionsQueryKey(id,params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof clientControllerGetStartedInterventions>>> = ({ signal }) => clientControllerGetStartedInterventions(id,params, signal);

  const query = useQuery<Awaited<ReturnType<typeof clientControllerGetStartedInterventions>>, TError, TData>(queryKey, queryFn, {enabled: !!(id), ...queryOptions})

  return {
    queryKey,
    ...query
  }
}


export const clientControllerDeleteIntervention = (
    id: string,
    clientInterventionId: string,
 
) => {
      return customInstance<void>(
      {url: `/client/${id}/interventions/${clientInterventionId}`, method: 'delete'
    },
      );
    }
  


    export type ClientControllerDeleteInterventionMutationResult = NonNullable<Awaited<ReturnType<typeof clientControllerDeleteIntervention>>>
    
    export type ClientControllerDeleteInterventionMutationError = ErrorType<unknown>

    export const useClientControllerDeleteIntervention = <TError = ErrorType<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clientControllerDeleteIntervention>>, TError,{id: string;clientInterventionId: string}, TContext>, }
) => {
      const {mutation: mutationOptions} = options ?? {}

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clientControllerDeleteIntervention>>, {id: string;clientInterventionId: string}> = (props) => {
          const {id,clientInterventionId} = props ?? {};

          return  clientControllerDeleteIntervention(id,clientInterventionId,)
        }

      return useMutation<Awaited<ReturnType<typeof clientControllerDeleteIntervention>>, TError, {id: string;clientInterventionId: string}, TContext>(mutationFn, mutationOptions)
    }
    
export const clientControllerDismissSafetyNet = (
    id: string,
 
) => {
      return customInstance<void>(
      {url: `/client/${id}/safety-net/dismiss`, method: 'patch'
    },
      );
    }
  


    export type ClientControllerDismissSafetyNetMutationResult = NonNullable<Awaited<ReturnType<typeof clientControllerDismissSafetyNet>>>
    
    export type ClientControllerDismissSafetyNetMutationError = ErrorType<unknown>

    export const useClientControllerDismissSafetyNet = <TError = ErrorType<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clientControllerDismissSafetyNet>>, TError,{id: string}, TContext>, }
) => {
      const {mutation: mutationOptions} = options ?? {}

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clientControllerDismissSafetyNet>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  clientControllerDismissSafetyNet(id,)
        }

      return useMutation<Awaited<ReturnType<typeof clientControllerDismissSafetyNet>>, TError, {id: string}, TContext>(mutationFn, mutationOptions)
    }
    
export const userControllerGetUser = (
    userId: string,
 signal?: AbortSignal
) => {
      return customInstance<UserDto>(
      {url: `/user/${userId}`, method: 'get', signal
    },
      );
    }
  

export const getUserControllerGetUserQueryKey = (userId: string,) => [`/user/${userId}`];

    
export type UserControllerGetUserQueryResult = NonNullable<Awaited<ReturnType<typeof userControllerGetUser>>>
export type UserControllerGetUserQueryError = ErrorType<ApiExceptionDto>

export const useUserControllerGetUser = <TData = Awaited<ReturnType<typeof userControllerGetUser>>, TError = ErrorType<ApiExceptionDto>>(
 userId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof userControllerGetUser>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions} = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getUserControllerGetUserQueryKey(userId);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof userControllerGetUser>>> = ({ signal }) => userControllerGetUser(userId, signal);

  const query = useQuery<Awaited<ReturnType<typeof userControllerGetUser>>, TError, TData>(queryKey, queryFn, {enabled: !!(userId), ...queryOptions})

  return {
    queryKey,
    ...query
  }
}


export const userControllerGetAssignedAssessments = (
    userId: string,
 signal?: AbortSignal
) => {
      return customInstance<AssignedAssessmentDto[]>(
      {url: `/user/${userId}/assigned-assessments`, method: 'get', signal
    },
      );
    }
  

export const getUserControllerGetAssignedAssessmentsQueryKey = (userId: string,) => [`/user/${userId}/assigned-assessments`];

    
export type UserControllerGetAssignedAssessmentsQueryResult = NonNullable<Awaited<ReturnType<typeof userControllerGetAssignedAssessments>>>
export type UserControllerGetAssignedAssessmentsQueryError = ErrorType<unknown>

export const useUserControllerGetAssignedAssessments = <TData = Awaited<ReturnType<typeof userControllerGetAssignedAssessments>>, TError = ErrorType<unknown>>(
 userId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof userControllerGetAssignedAssessments>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions} = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getUserControllerGetAssignedAssessmentsQueryKey(userId);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof userControllerGetAssignedAssessments>>> = ({ signal }) => userControllerGetAssignedAssessments(userId, signal);

  const query = useQuery<Awaited<ReturnType<typeof userControllerGetAssignedAssessments>>, TError, TData>(queryKey, queryFn, {enabled: !!(userId), ...queryOptions})

  return {
    queryKey,
    ...query
  }
}


export const userControllerPostSubmitAssessment = (
    userId: string,
    submittedAssessmentsBodyDto: SubmittedAssessmentsBodyDto,
    params?: UserControllerPostSubmitAssessmentParams,
 
) => {
      return customInstance<SubmittedAssessmentsDto>(
      {url: `/user/${userId}/submit-assessments`, method: 'post',
      headers: {'Content-Type': 'application/json'},
      data: submittedAssessmentsBodyDto,
        params,
    },
      );
    }
  


    export type UserControllerPostSubmitAssessmentMutationResult = NonNullable<Awaited<ReturnType<typeof userControllerPostSubmitAssessment>>>
    export type UserControllerPostSubmitAssessmentMutationBody = SubmittedAssessmentsBodyDto
    export type UserControllerPostSubmitAssessmentMutationError = ErrorType<unknown>

    export const useUserControllerPostSubmitAssessment = <TError = ErrorType<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userControllerPostSubmitAssessment>>, TError,{userId: string;data: SubmittedAssessmentsBodyDto;params?: UserControllerPostSubmitAssessmentParams}, TContext>, }
) => {
      const {mutation: mutationOptions} = options ?? {}

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userControllerPostSubmitAssessment>>, {userId: string;data: SubmittedAssessmentsBodyDto;params?: UserControllerPostSubmitAssessmentParams}> = (props) => {
          const {userId,data,params} = props ?? {};

          return  userControllerPostSubmitAssessment(userId,data,params,)
        }

      return useMutation<Awaited<ReturnType<typeof userControllerPostSubmitAssessment>>, TError, {userId: string;data: SubmittedAssessmentsBodyDto;params?: UserControllerPostSubmitAssessmentParams}, TContext>(mutationFn, mutationOptions)
    }
    
export const userControllerGetConsentInfo = (
    userId: string,
 signal?: AbortSignal
) => {
      return customInstance<ConsentInfoDto>(
      {url: `/user/${userId}/consent-info`, method: 'get', signal
    },
      );
    }
  

export const getUserControllerGetConsentInfoQueryKey = (userId: string,) => [`/user/${userId}/consent-info`];

    
export type UserControllerGetConsentInfoQueryResult = NonNullable<Awaited<ReturnType<typeof userControllerGetConsentInfo>>>
export type UserControllerGetConsentInfoQueryError = ErrorType<unknown>

export const useUserControllerGetConsentInfo = <TData = Awaited<ReturnType<typeof userControllerGetConsentInfo>>, TError = ErrorType<unknown>>(
 userId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof userControllerGetConsentInfo>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions} = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getUserControllerGetConsentInfoQueryKey(userId);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof userControllerGetConsentInfo>>> = ({ signal }) => userControllerGetConsentInfo(userId, signal);

  const query = useQuery<Awaited<ReturnType<typeof userControllerGetConsentInfo>>, TError, TData>(queryKey, queryFn, {enabled: !!(userId), ...queryOptions})

  return {
    queryKey,
    ...query
  }
}


export const userControllerPostAcceptConsent = (
    userId: string,
 
) => {
      return customInstance<void>(
      {url: `/user/${userId}/accept-consent`, method: 'post'
    },
      );
    }
  


    export type UserControllerPostAcceptConsentMutationResult = NonNullable<Awaited<ReturnType<typeof userControllerPostAcceptConsent>>>
    
    export type UserControllerPostAcceptConsentMutationError = ErrorType<unknown>

    export const useUserControllerPostAcceptConsent = <TError = ErrorType<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userControllerPostAcceptConsent>>, TError,{userId: string}, TContext>, }
) => {
      const {mutation: mutationOptions} = options ?? {}

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userControllerPostAcceptConsent>>, {userId: string}> = (props) => {
          const {userId} = props ?? {};

          return  userControllerPostAcceptConsent(userId,)
        }

      return useMutation<Awaited<ReturnType<typeof userControllerPostAcceptConsent>>, TError, {userId: string}, TContext>(mutationFn, mutationOptions)
    }
    
export const userControllerPostNotifyClinicianOfArrival = (
    userId: string,
 
) => {
      return customInstance<void>(
      {url: `/user/${userId}/notify-clinician-of-arrival`, method: 'post'
    },
      );
    }
  


    export type UserControllerPostNotifyClinicianOfArrivalMutationResult = NonNullable<Awaited<ReturnType<typeof userControllerPostNotifyClinicianOfArrival>>>
    
    export type UserControllerPostNotifyClinicianOfArrivalMutationError = ErrorType<unknown>

    export const useUserControllerPostNotifyClinicianOfArrival = <TError = ErrorType<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userControllerPostNotifyClinicianOfArrival>>, TError,{userId: string}, TContext>, }
) => {
      const {mutation: mutationOptions} = options ?? {}

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userControllerPostNotifyClinicianOfArrival>>, {userId: string}> = (props) => {
          const {userId} = props ?? {};

          return  userControllerPostNotifyClinicianOfArrival(userId,)
        }

      return useMutation<Awaited<ReturnType<typeof userControllerPostNotifyClinicianOfArrival>>, TError, {userId: string}, TContext>(mutationFn, mutationOptions)
    }
    
export const userControllerGetBranchLink = (
    userId: string,
 signal?: AbortSignal
) => {
      return customInstance<BranchLinkDto>(
      {url: `/user/${userId}/branch-link`, method: 'get', signal
    },
      );
    }
  

export const getUserControllerGetBranchLinkQueryKey = (userId: string,) => [`/user/${userId}/branch-link`];

    
export type UserControllerGetBranchLinkQueryResult = NonNullable<Awaited<ReturnType<typeof userControllerGetBranchLink>>>
export type UserControllerGetBranchLinkQueryError = ErrorType<unknown>

export const useUserControllerGetBranchLink = <TData = Awaited<ReturnType<typeof userControllerGetBranchLink>>, TError = ErrorType<unknown>>(
 userId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof userControllerGetBranchLink>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions} = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getUserControllerGetBranchLinkQueryKey(userId);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof userControllerGetBranchLink>>> = ({ signal }) => userControllerGetBranchLink(userId, signal);

  const query = useQuery<Awaited<ReturnType<typeof userControllerGetBranchLink>>, TError, TData>(queryKey, queryFn, {enabled: !!(userId), ...queryOptions})

  return {
    queryKey,
    ...query
  }
}


export const userControllerPostSendBranchLink = (
    userId: string,
 
) => {
      return customInstance<void>(
      {url: `/user/${userId}/send-branch-link`, method: 'post'
    },
      );
    }
  


    export type UserControllerPostSendBranchLinkMutationResult = NonNullable<Awaited<ReturnType<typeof userControllerPostSendBranchLink>>>
    
    export type UserControllerPostSendBranchLinkMutationError = ErrorType<unknown>

    export const useUserControllerPostSendBranchLink = <TError = ErrorType<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userControllerPostSendBranchLink>>, TError,{userId: string}, TContext>, }
) => {
      const {mutation: mutationOptions} = options ?? {}

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userControllerPostSendBranchLink>>, {userId: string}> = (props) => {
          const {userId} = props ?? {};

          return  userControllerPostSendBranchLink(userId,)
        }

      return useMutation<Awaited<ReturnType<typeof userControllerPostSendBranchLink>>, TError, {userId: string}, TContext>(mutationFn, mutationOptions)
    }
    
export const userControllerGetIntervention = (
    userId: string,
    clientInterventionId: string,
 signal?: AbortSignal
) => {
      return customInstance<void>(
      {url: `/user/${userId}/intervention/${clientInterventionId}`, method: 'get', signal
    },
      );
    }
  

export const getUserControllerGetInterventionQueryKey = (userId: string,
    clientInterventionId: string,) => [`/user/${userId}/intervention/${clientInterventionId}`];

    
export type UserControllerGetInterventionQueryResult = NonNullable<Awaited<ReturnType<typeof userControllerGetIntervention>>>
export type UserControllerGetInterventionQueryError = ErrorType<unknown>

export const useUserControllerGetIntervention = <TData = Awaited<ReturnType<typeof userControllerGetIntervention>>, TError = ErrorType<unknown>>(
 userId: string,
    clientInterventionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof userControllerGetIntervention>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions} = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getUserControllerGetInterventionQueryKey(userId,clientInterventionId);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof userControllerGetIntervention>>> = ({ signal }) => userControllerGetIntervention(userId,clientInterventionId, signal);

  const query = useQuery<Awaited<ReturnType<typeof userControllerGetIntervention>>, TError, TData>(queryKey, queryFn, {enabled: !!(userId && clientInterventionId), ...queryOptions})

  return {
    queryKey,
    ...query
  }
}


export const kioskControllerGetClinic = (
    clinicDisplayId: string,
 signal?: AbortSignal
) => {
      return customInstance<KioskClinicDto>(
      {url: `/kiosk/clinic/${clinicDisplayId}`, method: 'get', signal
    },
      );
    }
  

export const getKioskControllerGetClinicQueryKey = (clinicDisplayId: string,) => [`/kiosk/clinic/${clinicDisplayId}`];

    
export type KioskControllerGetClinicQueryResult = NonNullable<Awaited<ReturnType<typeof kioskControllerGetClinic>>>
export type KioskControllerGetClinicQueryError = ErrorType<ApiExceptionDto>

export const useKioskControllerGetClinic = <TData = Awaited<ReturnType<typeof kioskControllerGetClinic>>, TError = ErrorType<ApiExceptionDto>>(
 clinicDisplayId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof kioskControllerGetClinic>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions} = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getKioskControllerGetClinicQueryKey(clinicDisplayId);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof kioskControllerGetClinic>>> = ({ signal }) => kioskControllerGetClinic(clinicDisplayId, signal);

  const query = useQuery<Awaited<ReturnType<typeof kioskControllerGetClinic>>, TError, TData>(queryKey, queryFn, {enabled: !!(clinicDisplayId), ...queryOptions})

  return {
    queryKey,
    ...query
  }
}


export const kioskControllerGetClientById = (
    clientId: string,
 signal?: AbortSignal
) => {
      return customInstance<KioskClientDto>(
      {url: `/kiosk/clients/${clientId}`, method: 'get', signal
    },
      );
    }
  

export const getKioskControllerGetClientByIdQueryKey = (clientId: string,) => [`/kiosk/clients/${clientId}`];

    
export type KioskControllerGetClientByIdQueryResult = NonNullable<Awaited<ReturnType<typeof kioskControllerGetClientById>>>
export type KioskControllerGetClientByIdQueryError = ErrorType<ApiExceptionDto>

export const useKioskControllerGetClientById = <TData = Awaited<ReturnType<typeof kioskControllerGetClientById>>, TError = ErrorType<ApiExceptionDto>>(
 clientId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof kioskControllerGetClientById>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions} = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getKioskControllerGetClientByIdQueryKey(clientId);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof kioskControllerGetClientById>>> = ({ signal }) => kioskControllerGetClientById(clientId, signal);

  const query = useQuery<Awaited<ReturnType<typeof kioskControllerGetClientById>>, TError, TData>(queryKey, queryFn, {enabled: !!(clientId), ...queryOptions})

  return {
    queryKey,
    ...query
  }
}


export const kioskControllerPostIdentifyClientFromAttributes = (
    kioskIdentifyClientFromAttributesBodyDto: KioskIdentifyClientFromAttributesBodyDto,
 
) => {
      return customInstance<KioskIdentifyClientDto>(
      {url: `/kiosk/identify-client-attributes`, method: 'post',
      headers: {'Content-Type': 'application/json'},
      data: kioskIdentifyClientFromAttributesBodyDto
    },
      );
    }
  


    export type KioskControllerPostIdentifyClientFromAttributesMutationResult = NonNullable<Awaited<ReturnType<typeof kioskControllerPostIdentifyClientFromAttributes>>>
    export type KioskControllerPostIdentifyClientFromAttributesMutationBody = KioskIdentifyClientFromAttributesBodyDto
    export type KioskControllerPostIdentifyClientFromAttributesMutationError = ErrorType<ApiExceptionDto>

    export const useKioskControllerPostIdentifyClientFromAttributes = <TError = ErrorType<ApiExceptionDto>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof kioskControllerPostIdentifyClientFromAttributes>>, TError,{data: KioskIdentifyClientFromAttributesBodyDto}, TContext>, }
) => {
      const {mutation: mutationOptions} = options ?? {}

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof kioskControllerPostIdentifyClientFromAttributes>>, {data: KioskIdentifyClientFromAttributesBodyDto}> = (props) => {
          const {data} = props ?? {};

          return  kioskControllerPostIdentifyClientFromAttributes(data,)
        }

      return useMutation<Awaited<ReturnType<typeof kioskControllerPostIdentifyClientFromAttributes>>, TError, {data: KioskIdentifyClientFromAttributesBodyDto}, TContext>(mutationFn, mutationOptions)
    }
    
export const kioskControllerPostIdentifyClientFromMrn = (
    kioskIdentifyClientFromMRNBodyDto: KioskIdentifyClientFromMRNBodyDto,
 
) => {
      return customInstance<KioskIdentifyClientDto>(
      {url: `/kiosk/identify-client-mrn`, method: 'post',
      headers: {'Content-Type': 'application/json'},
      data: kioskIdentifyClientFromMRNBodyDto
    },
      );
    }
  


    export type KioskControllerPostIdentifyClientFromMrnMutationResult = NonNullable<Awaited<ReturnType<typeof kioskControllerPostIdentifyClientFromMrn>>>
    export type KioskControllerPostIdentifyClientFromMrnMutationBody = KioskIdentifyClientFromMRNBodyDto
    export type KioskControllerPostIdentifyClientFromMrnMutationError = ErrorType<ApiExceptionDto>

    export const useKioskControllerPostIdentifyClientFromMrn = <TError = ErrorType<ApiExceptionDto>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof kioskControllerPostIdentifyClientFromMrn>>, TError,{data: KioskIdentifyClientFromMRNBodyDto}, TContext>, }
) => {
      const {mutation: mutationOptions} = options ?? {}

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof kioskControllerPostIdentifyClientFromMrn>>, {data: KioskIdentifyClientFromMRNBodyDto}> = (props) => {
          const {data} = props ?? {};

          return  kioskControllerPostIdentifyClientFromMrn(data,)
        }

      return useMutation<Awaited<ReturnType<typeof kioskControllerPostIdentifyClientFromMrn>>, TError, {data: KioskIdentifyClientFromMRNBodyDto}, TContext>(mutationFn, mutationOptions)
    }
    
export const sessionControllerPostSession = (
    sessionCreateBodyDto: SessionCreateBodyDto,
 
) => {
      return customInstance<SessionDraftDto>(
      {url: `/sessions`, method: 'post',
      headers: {'Content-Type': 'application/json'},
      data: sessionCreateBodyDto
    },
      );
    }
  


    export type SessionControllerPostSessionMutationResult = NonNullable<Awaited<ReturnType<typeof sessionControllerPostSession>>>
    export type SessionControllerPostSessionMutationBody = SessionCreateBodyDto
    export type SessionControllerPostSessionMutationError = ErrorType<void>

    export const useSessionControllerPostSession = <TError = ErrorType<void>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionControllerPostSession>>, TError,{data: SessionCreateBodyDto}, TContext>, }
) => {
      const {mutation: mutationOptions} = options ?? {}

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sessionControllerPostSession>>, {data: SessionCreateBodyDto}> = (props) => {
          const {data} = props ?? {};

          return  sessionControllerPostSession(data,)
        }

      return useMutation<Awaited<ReturnType<typeof sessionControllerPostSession>>, TError, {data: SessionCreateBodyDto}, TContext>(mutationFn, mutationOptions)
    }
    
export const sessionControllerCreateSessionFromUploadedAudio = (
    sessionFromUploadedAudioBodyDto: SessionFromUploadedAudioBodyDto,
 
) => {
      return customInstance<void>(
      {url: `/sessions/from-uploaded-audio`, method: 'post',
      headers: {'Content-Type': 'application/json'},
      data: sessionFromUploadedAudioBodyDto
    },
      );
    }
  


    export type SessionControllerCreateSessionFromUploadedAudioMutationResult = NonNullable<Awaited<ReturnType<typeof sessionControllerCreateSessionFromUploadedAudio>>>
    export type SessionControllerCreateSessionFromUploadedAudioMutationBody = SessionFromUploadedAudioBodyDto
    export type SessionControllerCreateSessionFromUploadedAudioMutationError = ErrorType<unknown>

    export const useSessionControllerCreateSessionFromUploadedAudio = <TError = ErrorType<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionControllerCreateSessionFromUploadedAudio>>, TError,{data: SessionFromUploadedAudioBodyDto}, TContext>, }
) => {
      const {mutation: mutationOptions} = options ?? {}

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sessionControllerCreateSessionFromUploadedAudio>>, {data: SessionFromUploadedAudioBodyDto}> = (props) => {
          const {data} = props ?? {};

          return  sessionControllerCreateSessionFromUploadedAudio(data,)
        }

      return useMutation<Awaited<ReturnType<typeof sessionControllerCreateSessionFromUploadedAudio>>, TError, {data: SessionFromUploadedAudioBodyDto}, TContext>(mutationFn, mutationOptions)
    }
    
export const sessionControllerStartUpload = (
    startUploadDto: StartUploadDto,
 
) => {
      return customInstance<void>(
      {url: `/sessions/start-upload`, method: 'post',
      headers: {'Content-Type': 'application/json'},
      data: startUploadDto
    },
      );
    }
  


    export type SessionControllerStartUploadMutationResult = NonNullable<Awaited<ReturnType<typeof sessionControllerStartUpload>>>
    export type SessionControllerStartUploadMutationBody = StartUploadDto
    export type SessionControllerStartUploadMutationError = ErrorType<unknown>

    export const useSessionControllerStartUpload = <TError = ErrorType<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionControllerStartUpload>>, TError,{data: StartUploadDto}, TContext>, }
) => {
      const {mutation: mutationOptions} = options ?? {}

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sessionControllerStartUpload>>, {data: StartUploadDto}> = (props) => {
          const {data} = props ?? {};

          return  sessionControllerStartUpload(data,)
        }

      return useMutation<Awaited<ReturnType<typeof sessionControllerStartUpload>>, TError, {data: StartUploadDto}, TContext>(mutationFn, mutationOptions)
    }
    
export const sessionControllerCompleteUpload = (
    completeUploadDto: CompleteUploadDto,
 
) => {
      return customInstance<void>(
      {url: `/sessions/complete-upload`, method: 'post',
      headers: {'Content-Type': 'application/json'},
      data: completeUploadDto
    },
      );
    }
  


    export type SessionControllerCompleteUploadMutationResult = NonNullable<Awaited<ReturnType<typeof sessionControllerCompleteUpload>>>
    export type SessionControllerCompleteUploadMutationBody = CompleteUploadDto
    export type SessionControllerCompleteUploadMutationError = ErrorType<unknown>

    export const useSessionControllerCompleteUpload = <TError = ErrorType<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionControllerCompleteUpload>>, TError,{data: CompleteUploadDto}, TContext>, }
) => {
      const {mutation: mutationOptions} = options ?? {}

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sessionControllerCompleteUpload>>, {data: CompleteUploadDto}> = (props) => {
          const {data} = props ?? {};

          return  sessionControllerCompleteUpload(data,)
        }

      return useMutation<Awaited<ReturnType<typeof sessionControllerCompleteUpload>>, TError, {data: CompleteUploadDto}, TContext>(mutationFn, mutationOptions)
    }
    
export const sessionControllerCreateSampleSession = (
    sampleSessionDto: SampleSessionDto,
 
) => {
      return customInstance<void>(
      {url: `/sessions/sample`, method: 'post',
      headers: {'Content-Type': 'application/json'},
      data: sampleSessionDto
    },
      );
    }
  


    export type SessionControllerCreateSampleSessionMutationResult = NonNullable<Awaited<ReturnType<typeof sessionControllerCreateSampleSession>>>
    export type SessionControllerCreateSampleSessionMutationBody = SampleSessionDto
    export type SessionControllerCreateSampleSessionMutationError = ErrorType<unknown>

    export const useSessionControllerCreateSampleSession = <TError = ErrorType<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionControllerCreateSampleSession>>, TError,{data: SampleSessionDto}, TContext>, }
) => {
      const {mutation: mutationOptions} = options ?? {}

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sessionControllerCreateSampleSession>>, {data: SampleSessionDto}> = (props) => {
          const {data} = props ?? {};

          return  sessionControllerCreateSampleSession(data,)
        }

      return useMutation<Awaited<ReturnType<typeof sessionControllerCreateSampleSession>>, TError, {data: SampleSessionDto}, TContext>(mutationFn, mutationOptions)
    }
    
export const sessionControllerGetNotes = (
    id: string,
 signal?: AbortSignal
) => {
      return customInstance<SessionCompletedDto>(
      {url: `/sessions/${id}/notes`, method: 'get', signal
    },
      );
    }
  

export const getSessionControllerGetNotesQueryKey = (id: string,) => [`/sessions/${id}/notes`];

    
export type SessionControllerGetNotesQueryResult = NonNullable<Awaited<ReturnType<typeof sessionControllerGetNotes>>>
export type SessionControllerGetNotesQueryError = ErrorType<void>

export const useSessionControllerGetNotes = <TData = Awaited<ReturnType<typeof sessionControllerGetNotes>>, TError = ErrorType<void>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof sessionControllerGetNotes>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions} = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getSessionControllerGetNotesQueryKey(id);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof sessionControllerGetNotes>>> = ({ signal }) => sessionControllerGetNotes(id, signal);

  const query = useQuery<Awaited<ReturnType<typeof sessionControllerGetNotes>>, TError, TData>(queryKey, queryFn, {enabled: !!(id), ...queryOptions})

  return {
    queryKey,
    ...query
  }
}


export const sessionControllerGetProgressNote = (
    id: string,
 signal?: AbortSignal
) => {
      return customInstance<SessionProgressNoteDto>(
      {url: `/sessions/${id}/progress-note`, method: 'get', signal
    },
      );
    }
  

export const getSessionControllerGetProgressNoteQueryKey = (id: string,) => [`/sessions/${id}/progress-note`];

    
export type SessionControllerGetProgressNoteQueryResult = NonNullable<Awaited<ReturnType<typeof sessionControllerGetProgressNote>>>
export type SessionControllerGetProgressNoteQueryError = ErrorType<void>

export const useSessionControllerGetProgressNote = <TData = Awaited<ReturnType<typeof sessionControllerGetProgressNote>>, TError = ErrorType<void>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof sessionControllerGetProgressNote>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions} = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getSessionControllerGetProgressNoteQueryKey(id);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof sessionControllerGetProgressNote>>> = ({ signal }) => sessionControllerGetProgressNote(id, signal);

  const query = useQuery<Awaited<ReturnType<typeof sessionControllerGetProgressNote>>, TError, TData>(queryKey, queryFn, {enabled: !!(id), ...queryOptions})

  return {
    queryKey,
    ...query
  }
}


export const sessionControllerGetProgressNotesForSession = (
    id: string,
 signal?: AbortSignal
) => {
      return customInstance<SessionProgressNoteDto>(
      {url: `/sessions/${id}/progress-notes`, method: 'get', signal
    },
      );
    }
  

export const getSessionControllerGetProgressNotesForSessionQueryKey = (id: string,) => [`/sessions/${id}/progress-notes`];

    
export type SessionControllerGetProgressNotesForSessionQueryResult = NonNullable<Awaited<ReturnType<typeof sessionControllerGetProgressNotesForSession>>>
export type SessionControllerGetProgressNotesForSessionQueryError = ErrorType<void>

export const useSessionControllerGetProgressNotesForSession = <TData = Awaited<ReturnType<typeof sessionControllerGetProgressNotesForSession>>, TError = ErrorType<void>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof sessionControllerGetProgressNotesForSession>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions} = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getSessionControllerGetProgressNotesForSessionQueryKey(id);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof sessionControllerGetProgressNotesForSession>>> = ({ signal }) => sessionControllerGetProgressNotesForSession(id, signal);

  const query = useQuery<Awaited<ReturnType<typeof sessionControllerGetProgressNotesForSession>>, TError, TData>(queryKey, queryFn, {enabled: !!(id), ...queryOptions})

  return {
    queryKey,
    ...query
  }
}


export const sessionControllerTrackEvent = (
    id: string,
    trackEventDto: TrackEventDto,
 
) => {
      return customInstance<void>(
      {url: `/sessions/${id}/track-event`, method: 'post',
      headers: {'Content-Type': 'application/json'},
      data: trackEventDto
    },
      );
    }
  


    export type SessionControllerTrackEventMutationResult = NonNullable<Awaited<ReturnType<typeof sessionControllerTrackEvent>>>
    export type SessionControllerTrackEventMutationBody = TrackEventDto
    export type SessionControllerTrackEventMutationError = ErrorType<unknown>

    export const useSessionControllerTrackEvent = <TError = ErrorType<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionControllerTrackEvent>>, TError,{id: string;data: TrackEventDto}, TContext>, }
) => {
      const {mutation: mutationOptions} = options ?? {}

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sessionControllerTrackEvent>>, {id: string;data: TrackEventDto}> = (props) => {
          const {id,data} = props ?? {};

          return  sessionControllerTrackEvent(id,data,)
        }

      return useMutation<Awaited<ReturnType<typeof sessionControllerTrackEvent>>, TError, {id: string;data: TrackEventDto}, TContext>(mutationFn, mutationOptions)
    }
    
export const sessionControllerPatchProgressNote = (
    id: string,
    noteId: string,
    patchNoteDto: PatchNoteDto,
 
) => {
      return customInstance<void>(
      {url: `/sessions/${id}/notes/${noteId}`, method: 'patch',
      headers: {'Content-Type': 'application/json'},
      data: patchNoteDto
    },
      );
    }
  


    export type SessionControllerPatchProgressNoteMutationResult = NonNullable<Awaited<ReturnType<typeof sessionControllerPatchProgressNote>>>
    export type SessionControllerPatchProgressNoteMutationBody = PatchNoteDto
    export type SessionControllerPatchProgressNoteMutationError = ErrorType<unknown>

    export const useSessionControllerPatchProgressNote = <TError = ErrorType<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionControllerPatchProgressNote>>, TError,{id: string;noteId: string;data: PatchNoteDto}, TContext>, }
) => {
      const {mutation: mutationOptions} = options ?? {}

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sessionControllerPatchProgressNote>>, {id: string;noteId: string;data: PatchNoteDto}> = (props) => {
          const {id,noteId,data} = props ?? {};

          return  sessionControllerPatchProgressNote(id,noteId,data,)
        }

      return useMutation<Awaited<ReturnType<typeof sessionControllerPatchProgressNote>>, TError, {id: string;noteId: string;data: PatchNoteDto}, TContext>(mutationFn, mutationOptions)
    }
    
export const sessionControllerGetSessionRecap = (
    id: string,
 signal?: AbortSignal
) => {
      return customInstance<SessionRecapDto>(
      {url: `/sessions/${id}/recap`, method: 'get', signal
    },
      );
    }
  

export const getSessionControllerGetSessionRecapQueryKey = (id: string,) => [`/sessions/${id}/recap`];

    
export type SessionControllerGetSessionRecapQueryResult = NonNullable<Awaited<ReturnType<typeof sessionControllerGetSessionRecap>>>
export type SessionControllerGetSessionRecapQueryError = ErrorType<void>

export const useSessionControllerGetSessionRecap = <TData = Awaited<ReturnType<typeof sessionControllerGetSessionRecap>>, TError = ErrorType<void>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof sessionControllerGetSessionRecap>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions} = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getSessionControllerGetSessionRecapQueryKey(id);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof sessionControllerGetSessionRecap>>> = ({ signal }) => sessionControllerGetSessionRecap(id, signal);

  const query = useQuery<Awaited<ReturnType<typeof sessionControllerGetSessionRecap>>, TError, TData>(queryKey, queryFn, {enabled: !!(id), ...queryOptions})

  return {
    queryKey,
    ...query
  }
}


export const sessionControllerPostSessionMarkComplete = (
    id: string,
    markCompleteDto: MarkCompleteDto,
 
) => {
      return customInstance<void>(
      {url: `/sessions/${id}/mark-complete`, method: 'post',
      headers: {'Content-Type': 'application/json'},
      data: markCompleteDto
    },
      );
    }
  


    export type SessionControllerPostSessionMarkCompleteMutationResult = NonNullable<Awaited<ReturnType<typeof sessionControllerPostSessionMarkComplete>>>
    export type SessionControllerPostSessionMarkCompleteMutationBody = MarkCompleteDto
    export type SessionControllerPostSessionMarkCompleteMutationError = ErrorType<unknown>

    export const useSessionControllerPostSessionMarkComplete = <TError = ErrorType<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionControllerPostSessionMarkComplete>>, TError,{id: string;data: MarkCompleteDto}, TContext>, }
) => {
      const {mutation: mutationOptions} = options ?? {}

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sessionControllerPostSessionMarkComplete>>, {id: string;data: MarkCompleteDto}> = (props) => {
          const {id,data} = props ?? {};

          return  sessionControllerPostSessionMarkComplete(id,data,)
        }

      return useMutation<Awaited<ReturnType<typeof sessionControllerPostSessionMarkComplete>>, TError, {id: string;data: MarkCompleteDto}, TContext>(mutationFn, mutationOptions)
    }
    
export const sessionControllerPostDiscardSession = (
    id: string,
 
) => {
      return customInstance<void>(
      {url: `/sessions/${id}/discard-session`, method: 'post'
    },
      );
    }
  


    export type SessionControllerPostDiscardSessionMutationResult = NonNullable<Awaited<ReturnType<typeof sessionControllerPostDiscardSession>>>
    
    export type SessionControllerPostDiscardSessionMutationError = ErrorType<unknown>

    export const useSessionControllerPostDiscardSession = <TError = ErrorType<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionControllerPostDiscardSession>>, TError,{id: string}, TContext>, }
) => {
      const {mutation: mutationOptions} = options ?? {}

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sessionControllerPostDiscardSession>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  sessionControllerPostDiscardSession(id,)
        }

      return useMutation<Awaited<ReturnType<typeof sessionControllerPostDiscardSession>>, TError, {id: string}, TContext>(mutationFn, mutationOptions)
    }
    
export const sessionControllerPostPlannedInterventions = (
    id: string,
    sessionPlannedInterventionsBodyDto: SessionPlannedInterventionsBodyDto,
 
) => {
      return customInstance<void>(
      {url: `/sessions/${id}/planned-interventions`, method: 'post',
      headers: {'Content-Type': 'application/json'},
      data: sessionPlannedInterventionsBodyDto
    },
      );
    }
  


    export type SessionControllerPostPlannedInterventionsMutationResult = NonNullable<Awaited<ReturnType<typeof sessionControllerPostPlannedInterventions>>>
    export type SessionControllerPostPlannedInterventionsMutationBody = SessionPlannedInterventionsBodyDto
    export type SessionControllerPostPlannedInterventionsMutationError = ErrorType<unknown>

    export const useSessionControllerPostPlannedInterventions = <TError = ErrorType<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionControllerPostPlannedInterventions>>, TError,{id: string;data: SessionPlannedInterventionsBodyDto}, TContext>, }
) => {
      const {mutation: mutationOptions} = options ?? {}

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sessionControllerPostPlannedInterventions>>, {id: string;data: SessionPlannedInterventionsBodyDto}> = (props) => {
          const {id,data} = props ?? {};

          return  sessionControllerPostPlannedInterventions(id,data,)
        }

      return useMutation<Awaited<ReturnType<typeof sessionControllerPostPlannedInterventions>>, TError, {id: string;data: SessionPlannedInterventionsBodyDto}, TContext>(mutationFn, mutationOptions)
    }
    
export const sessionControllerPostPsychotherapyNote = (
    id: string,
    sessionPsychotherapyNoteBodyDto: SessionPsychotherapyNoteBodyDto,
 
) => {
      return customInstance<void>(
      {url: `/sessions/${id}/psychotherapy-note`, method: 'post',
      headers: {'Content-Type': 'application/json'},
      data: sessionPsychotherapyNoteBodyDto
    },
      );
    }
  


    export type SessionControllerPostPsychotherapyNoteMutationResult = NonNullable<Awaited<ReturnType<typeof sessionControllerPostPsychotherapyNote>>>
    export type SessionControllerPostPsychotherapyNoteMutationBody = SessionPsychotherapyNoteBodyDto
    export type SessionControllerPostPsychotherapyNoteMutationError = ErrorType<unknown>

    export const useSessionControllerPostPsychotherapyNote = <TError = ErrorType<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionControllerPostPsychotherapyNote>>, TError,{id: string;data: SessionPsychotherapyNoteBodyDto}, TContext>, }
) => {
      const {mutation: mutationOptions} = options ?? {}

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sessionControllerPostPsychotherapyNote>>, {id: string;data: SessionPsychotherapyNoteBodyDto}> = (props) => {
          const {id,data} = props ?? {};

          return  sessionControllerPostPsychotherapyNote(id,data,)
        }

      return useMutation<Awaited<ReturnType<typeof sessionControllerPostPsychotherapyNote>>, TError, {id: string;data: SessionPsychotherapyNoteBodyDto}, TContext>(mutationFn, mutationOptions)
    }
    
